import { ApiResponseDTO } from './api-response.dto';

export class ApiResponseArrayDTO<T> extends ApiResponseDTO {

    data: Array<T>;
    
}
